<template>
    <div>
        <div class="top-title-content">
            <span class="title">출석현황</span>
            <span class="txt">회원의 출석현황을 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap center">
                    <button :disabled="isLoading" class="prev-day" @click="onClickPrevMonth"></button>
                    <div class="ui-month-calendar">
                        <vue-monthly-picker
                            v-model="currentMonth"
                            :disabled="isLoading"
                            dateFormat="YYYY년 MM월"
                        />
                    </div>
                    <button :disabled="isLoading" class="next-day" @click="onClickNextMonth"></button>
                </div>

                <div class="com-search-input">
                    <input
                        v-model="searchText"
                        placeholder="회원명"
                        type="text"
                        v-on:keyup.enter="onSearch"
                    />
                    <button class="search-btn" @click="onSearch">검색</button>
                </div>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area" v-if="hasMessageEvent">
                <div class="message">
                    <select-form
                        :select-data="['메시지 전송 범위', '선택한 회원', '조회된 회원']"
                        :select-value="['', 'S', 'T']"
                        :selected-value="targetType"
                        @update:set="(val) => targetType = val"
                    />

                    <select-form
                        :select-data="['메시지 유형', 'SMS', '알림톡']"
                        :select-value="['', 'sms', 'talk']"
                        :selected-value="messageType"
                        @update:set="(val) => messageType = val"
                    />

                    <button
                        v-if='targetType && messageType && (targetType === "T" || selectedCustomers.length > 0)'
                        class="com-btn deep-blue"
                        @click="onSendMessage"
                    >
                        메시지 발송
                    </button>
                </div>
            </div>

            <loading-spinner v-if="isLoading"></loading-spinner>

            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 80px" />
                    <col style="width: 22%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                </colgroup>

                <thead>
                <tr>
                    <th>
                        <div class="com-check">
                            <input
                                id="check-1-1"
                                v-model="selectAll"
                                name="check-1"
                                type="checkbox"
                                @change="onSelectAll"
                            />
                            <label for="check-1-1"></label>
                        </div>
                    </th>
                    <th>
                        <button @click="onClickColumn('name')">회원명</button>
                    </th>
                    <th>
                        <button @click="onClickColumn('p_count')">개인 레슨</button>
                    </th>
                    <th>
                        <button @click="onClickColumn('d_count')">듀엣 레슨</button>
                    </th>
                    <th>
                        <button @click="onClickColumn('g_count')">그룹 레슨</button>
                    </th>
                    <th>
                        <button @click="onClickColumn('o_count')">OT 수업</button>
                    </th>
                    <th>
                        <button @click="onClickColumn('t_count')">센터 입장</button>
                    </th>
                    <th>
                      <button @click="onClickColumn('total_count')">총횟수</button>
                    </th>
                </tr>
                </thead>

                <tbody>
                    <tr v-for="stat in statData" :key="stat.center_cust_id">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-1-1-${stat.center_cust_id}`"
                                    v-model="selectedCustomers"
                                    :value="stat"
                                    name="check-1"
                                    type="checkbox"
                                />
                                <label :for="`check-1-1-${stat.center_cust_id}`"></label>
                            </div>
                        </td>

                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/payment/${centerId}`,
                                    query: { customerId: stat.center_cust_id },
                                }"
                                class="link"
                            >
                                {{ stat.name }}
                            </router-link>
                        </td>
                        <td>
                            <a v-if='stat.p_count' href='#' class='link count-link' @click.prevent="onClickLessonCount(stat.center_cust_id, 'P')">{{ stat.p_count }}</a>
                            <span v-else>{{ stat.p_count }}</span>
                        </td>
                        <td>
                            <a v-if='stat.d_count' href='#' class='link count-link' @click.prevent="onClickLessonCount(stat.center_cust_id, 'D')">{{ stat.d_count }}</a>
                            <span v-else>{{ stat.d_count }}</span>
                        </td>
                        <td>
                            <a v-if='stat.g_count' href='#' class='link count-link' @click.prevent="onClickLessonCount(stat.center_cust_id, 'G')">{{ stat.g_count }}</a>
                            <span v-else>{{ stat.g_count }}</span>
                        </td>
                        <td>
                            <a v-if='stat.o_count' href='#' class='link count-link' @click.prevent="onClickLessonCount(stat.center_cust_id, 'O')">{{ stat.o_count }}</a>
                            <span v-else>{{ stat.o_count }}</span>
                        </td>
                        <td>
                            <a v-if='stat.t_count' href='#' class='link count-link' @click.prevent="onClickLessonCount(stat.center_cust_id, 'T')">{{ stat.t_count }}</a>
                            <span v-else>{{ stat.t_count }}</span>
                        </td>
                        <td>{{ stat.total_count }}</td>
                    </tr>

                    <tr v-if="statData.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>

            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="export2Excel">엑셀 다운로드</button>

                <select-form
                    :select-data="sortTypeList"
                    :select-value="sortTypeValueList"
                    class="float-right"
                    @update:set="onPageSizeChange"
                />
            </div>
        </div>

        <b-pagination
            v-model="paging.page"
            :per-page="paging.limit"
            :total-rows="paging.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlePagination($event)"
        />
    </div>
</template>

<script>
import moment from 'moment/moment';
import XLSX from 'xlsx';
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import TicketUsage from '@/components/history/TicketUsage.vue';
import SelectForm from '@/components/SelectForm.vue';

export default {
    name: 'HistoryAttendance',
    components: {SelectForm, LoadingSpinner},

    data() {
        return {
            isLoading: false,
            currentMonth: moment(), // 년월

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            selectedCustomers: [], // 체크박스 선택한 회원 목록

            statData: [],

            paging: {
                page: 1,
                limit: 10,
            },

            sortType: 'DESC',
            sortColumn: '',

            searchText: '',

            selectAll: false, // 전체 선택 해제

            hasMessageEvent: false, // 권한에 따른 메세지 발송 버튼

            targetType: '',
            messageType: '',
        }
    },

    computed: {
        centerId() {
            return this.$store.getters['auth/cId'];
        },
    },

    mounted() {
        // 메시지보낼수 있는지 없는지 체크..
        this.checkMessageEvent();
    },

    activated() {
        this.fetchStatData();
    },

    watch: {
        currentMonth() {
            this.fetchStatData();
        },

        statData() {
            this.selectAll = false;
            this.selectedCustomers.length = 0;
        }
    },

    methods: {
        checkMessageEvent() {
            api.get('/admin/api/center/ftcontract/sms')
            .then((res) => {
                this.hasMessageEvent = JSON.parse(res.data);
            })
            .catch((error) => {
                this.hasMessageEvent = false;
            });
        },

        onClickNextMonth() {
            this.paging.page = 1;
            this.sortColumn = '';
            this.sortType = '';

            this.currentMonth = moment(this.currentMonth).add(1, 'months');
        },

        onClickPrevMonth() {
            this.paging.page = 1;
            this.sortColumn = '';
            this.sortType = '';

            this.currentMonth = moment(this.currentMonth).subtract(1, 'months');
        },

        onClickColumn(column) {
            if (this.sortColumn !== column) {
                this.sortColumn = column;
                this.sortType = '';
            }

            if (this.sortType === '') {
                this.sortType = 'DESC';
            } else if (this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = '';
            }

            this.fetchStatData();
        },

        // 회원 목록 키워드 검색 이벤트
        onSearch() {
            this.paging.page = 1;

            this.fetchStatData();
        },

        onPageSizeChange(val) {
            this.paging.limit = val;
            this.fetchStatData();
        },

        async handlePagination(event) {
            this.paging.page = event;

            await this.fetchStatData();

            // const checkList = this.checkSelectAll(this.selectedCustomers, this.customerList);
            // if (checkList === this.pagingInfo.limit) {
            //     this.selectAll = true;
            // } else {
            //     this.selectAll = false;
            // }
        },

        onSelectAll() {
            this.selectedCustomers.length = 0;

            if (this.selectAll) {
                this.selectedCustomers.push(...this.statData);
            }
        },

        onClickLessonCount(customer_id, ticket_type) {
            this.$modal.show(
                TicketUsage,
                {
                    month: this.currentMonth.format('YYYYMM'),
                    centerId: this.centerId,
                    customerId: customer_id,
                    ticketType: ticket_type,
                },
                {
                    width: 640,
                    height: 640,
                }
            );
        },

        async onSendMessage() {
            let customers;
            if (this.targetType === 'T') {
                customers = await this.fetchStatDataForExport();
            } else {
                customers = this.selectedCustomers;
            }

            await this.$router.push({
                name: this.messageType === 'sms' ? 'messageSend' : 'messageSendAlert',
                params: {
                    data: customers.map(item => {
                        return {
                            centerCustomerId: item.center_cust_id,
                            name: item.name,
                            phone: item.phone,
                        }
                    }),
                },
            });
        },

        async export2Excel() {
            const items = await this.fetchStatDataForExport();

            const rows = [];
            items.forEach((item) => {
                const row = {
                    '회원명': item.name,
                    '개인 레슨': item.p_count,
                    '듀엣 레슨': item.d_count,
                    '그룹 레슨': item.g_count,
                    'OT 수업': item.o_count,
                    '센터 입장': item.t_count,
                    '총횟수': item.total_count,
                };

                rows.push(row);
            });

            const ws = XLSX.utils.json_to_sheet(rows);

            // cell width 설정
            ws['!cols'] = [
                { wch: 20 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];

            // cell height 설정
            ws['!rows'] = [{ hpx: 30 }];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, this.currentMonth.format('YYYYMM'));
            XLSX.writeFile(wb, `출석현황_${this.currentMonth.format('YYYYMM')}.xlsx`);
        },

        setPageParams(meta) {
            this.paging.totalPages = meta.totalPages;
            this.paging.page = meta.currentPage;
            this.paging.totalItems = meta.totalItems;
            this.paging.itemCount = meta.itemCount;
        },

        async fetchStatData() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/attendance/stat`, {
                params: {
                    month: this.currentMonth.format('YYYYMM'),
                    searchText: this.searchText,
                    sortType: this.sortType,
                    sortColumn: this.sortColumn,
                    ...this.paging,
                },
            });

            this.statData = data.items;

            this.setPageParams(data.meta);
        },

        async fetchStatDataForExport() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/attendance/stat`, {
                params: {
                    month: this.currentMonth.format('YYYYMM'),
                    searchText: this.searchText,
                    sortType: this.sortType,
                    sortColumn: this.sortColumn,
                    page: 1,
                    limit: 10000,
                },
            });

            return data.items;
        },
    }
}
</script>

<style scoped lang='scss'>
.com-btn-area .message {
    display: flex;
    align-items: center;
    height: 36px;
}

.com-table td .count-link {
    text-decoration: underline !important;
}
</style>
